<template>
  <span>
    <span v-if="!isMe || !$store.state.edit.on">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="empty ? placeholder : viewAbleText" />
    </span>
    <span v-else>
      <!-- eslint-disable vue/no-v-html -->
      <span
        ref="display"
        class="iblock"
        @click="edit"
        @mouseover="hover = true"
        @mouseout="hover = false"
        v-html="empty ? placeholder : viewAbleText"
      />
      <!-- eslint-enable vue/no-v-html -->
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseModal
        :header-text="$t('Edit description')"
        :is-open="editing"
        :save-state="saveState"
        :disabled="loading"
        @cancel="modalCancel"
        @save="saveChanges"
        @opened="() => ($refs.input.style.height = $refs.display.offsetHeight + 'px')"
      >
        <textarea
          ref="input"
          v-model="mutableText"
          :placeholder="placeholder"
          :style="{ height: inputHeight + 'px' }"
          class="form-control ncase f-14 m-t-10 bgm-lightgray"
        />
      </BaseModal>
    </span>
  </span>
</template>

<script>
import autosize from 'autosize'
import gql from 'graphql-tag'
import { nextTick } from 'vue'
import enums from '@/utils/enum'
import { SET_EDITABLE_ACTIVE_STATE, SET_EDIT_UNSAVED } from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'

export default {
  name: 'EditProfileDescription',
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: $t('Add text here'),
    },
    viewHtml: {
      type: String,
      required: true,
    },
    editableText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mutableText: '',
      viewAbleText: '',
      revertText: '',
      editing: false,
      loading: false,
      hover: false,
      failed: false,
      inputHeight: 150,
      saveState: 'fresh',
    }
  },
  computed: {
    empty: {
      get() {
        return this.mutableText === '' || this.mutableText == null
      },
    },
  },
  watch: {
    loading(saving) {
      this.$store.dispatch(SET_EDIT_SAVING_STATE, saving)
    },
    editing() {
      this.$store.commit(SET_EDITABLE_ACTIVE_STATE, this.editing)
      this.$store.commit(SET_EDIT_UNSAVED, this.editing)
    },
  },
  created() {
    this.mutableText = this.editableText
    this.revertText = this.editableText
    this.viewAbleText = this.viewHtml
  },
  mounted() {
    if (typeof autosize === 'function') {
      autosize(this.$refs.input)
    }
  },
  methods: {
    modalCancel() {
      this.editing = false
      this.mutableText = this.revertText
    },
    edit() {
      this.editing = true
      this.inputHeight =
        this.$refs.display.offsetHeight > 150 ? this.$refs.display.offsetHeight : 150
      nextTick(() => {
        this.$refs.input.focus()
        if (typeof autosize === 'function') {
          autosize(this.$refs.input)
        }
      })
    },

    async saveChanges() {
      if (this.mutableText === this.revertText) {
        this.editing = false
        return
      }
      this.loading = true
      this.saveState = 'saving'
      try {
        const profileUpdate = await this.$apollo.mutate({
          mutation: gql`
            mutation update($profileData: UpdateProfileInput!) {
              updateProfile(input: $profileData) {
                description_display
                publicKey
              }
            }
          `,
          variables: {
            profileData: {
              localId: this.account.profile.id,
              description: this.mutableText,
            },
          },
        })

        this.viewAbleText = profileUpdate.data.updateProfile.description_display
        this.saveState = 'saved'
        this.revertText = this.mutableText
        setTimeout(() => {
          this.editing = false
          this.saveState = 'fresh'
        }, 1000)
      } catch (e) {
        this.$store.commit('sendNotification', {
          type: enums.notification.types.ERROR,
          sender: this,
          severity: enums.notification.severity.CRITICAL,
        })
        setTimeout(() => {
          this.saveState = 'fresh'
        }, 2000)
        this.failed = true
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
textarea {
  width: 100% !important;
}
</style>
